import { httpResource } from '@angular/common/http';
import { computed, Injectable, signal } from '@angular/core';
import { MapaApi } from './mapa.api';

@Injectable({
  providedIn: 'root'
})
export class CSCApi extends MapaApi {
  public readonly countries = (() => {
    const trigger = signal(false);

    const url = computed(() => trigger() ? `${MapaApi.url}/csc/countries` : undefined);

    const resource = httpResource<Country[]>(url, {
      defaultValue: []
    });

    return () => {
      trigger.set(true);
      return resource;
    };
  })();
}

export interface Country {
  id: number;
  name: string;
  iso2: string;
  iso3: string;

  currency: string;
  phonecode: string;
  emoji: string;
  timezones: Timezone[];
  translations: { [key: string]: string; };
}

export interface State {
  id: number;
  name: string;
  iso2: string;

  country_iso2: string;
  country_id: number;
}

export interface City {
  id: number;
  name: string;
}

export interface Timezone {
  zoneName: string;
  gmtOffset: number;
  gmtOffsetName: string;
  abbreviation: string;
  tzName: string;
}

// TODO: remove this when issue is resolved
const fixes = {
  country: {
    149: {
      translations: { "ko": "모로코", "pt-BR": "Marrocos", "pt": "Marrocos", "nl": "Marokko", "hr": "Maroko", "fa": "مراکش", "de": "Marokko", "es": "Marruecos", "fr": "Maroc", "ja": "モロッコ", "it": "Marocco", "zh-CN": "摩洛哥", "tr": "Fas", "ru": "Марокко", "uk": "Марокко", "pl": "Marobr" }
    },
    178: {
      translations: { "ko": "푸에르토리코", "pt-BR": "Porto Rico", "pt": "Porto Rico", "nl": "Puerto Rico", "hr": "Portoriko", "fa": "پورتو ریکو", "de": "Puerto Rico", "es": "Puerto Rico", "fr": "Porto Rico", "ja": "プエルトリコ", "it": "Porto Rico", "zh-CN": "波多黎各", "tr": "Porto Riko", "ru": "Пуэрто-Рико", "uk": "Пуерто-Ріко", "pl": "Portorybr" }
    }
  } as Record<number, {
    translations: Record<string, string>;
  }>
} as const;


function hydrateCountryTranslation(country: Country, translation: string) {
  try {
    country.translations = JSON.parse(translation);
  }
  catch {
    country.translations = fixes.country[country.id].translations ?? null;
  }
}
